<template>
    <div class="clearfix mb20">
        <div class="itinerary-content ib-con mb20 p10">
            <div v-for="(itinerary, index) in flight.itineraries" class="row align-items-center mb-3 p10">
                <div class="col-md-6 col-6 mb-3">
                    <img src="@/assets/img/svg/img_icon_flighttake_off.svg">
                    <div class="inline-middle pl-3 pr-3">
                        <h4 class="bold mb0">
                            {{ $t('flight') }} {{ index + 1 }} :
                            {{ itinerary.segments[0].departure.iataName }} {{ $t('To') }}
                            {{ itinerary.segments[itinerary.segments.length - 1].arrival.iataName }}
                        </h4>
                    </div>
                </div>
                <div class="col-md-6 col-6 mb-3">
                    <router-link v-if="index == 0 && detailedFareRules != null" to="/flight-policies/3"
                        class="btn-view-policies new-light pull-right">
                        <span class="inline-middle mr5 ml5">{{ $t('View Policies') }}</span>
                        <i class="fl-30-ico fl-fare-rules-green"></i>
                    </router-link>
                </div>
                <div class="col-md-12">
                    <div class="bg-white">
                        <div id="outbound-map" class="flight-map">
                            <img :src="index == 0 ? this.getOutboundImg : this.getInboundImg">
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="arrival-itinerary ib-con">
                        <div class="itinerary">
                            <div v-for="(segment, index) in itinerary.segments">
                                <div class="row no-margin p20 fl-itinerary">
                                    <div class="col-md-4 mt20 text-center">
                                        <div>
                                            <h3 class="prime-color">
                                                {{ segment.departure.iataCode }}
                                            </h3>
                                            <h4 class="no-margin new-light">
                                                {{ getFormattedTime(segment.departure.at) }}
                                            </h4>
                                            <span>
                                                {{ getFormattedDate(segment.departure.at) }}
                                            </span>
                                        </div>
                                        <div>
                                            <div class="ellipsis no-wrap font-sm">
                                                {{ segment.departure.airportName }}
                                            </div>
                                            <div class="ellipsis no-wrap font-sm">
                                                {{ segment.departure.iataName }},
                                                {{ segment.departure.countryName }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 text-center">
                                        <div class="mb5">
                                            <div class="fl-img-con">
                                                <div :class="'flight-image i-' + segment.carrierCode.toLowerCase()">
                                                </div>
                                            </div>
                                            <p class="no-margin font-12 font-sm">
                                                <span>{{ segment.carrierName }}</span>
                                            <p class="clearfix">
                                                {{ segment.carrierCode }}{{ segment.number }}
                                            </p>
                                            </p>
                                            <span>{{ $t(this.searchData.cabin) }}</span>
                                        </div>
                                        <div>
                                            <div>{{ convertDuration(segment.duration) }}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mt20 text-center">
                                        <div>
                                            <h3 class="prime-color">{{ segment.arrival.iataCode }}</h3>
                                            <h4 class="no-margin new-light">
                                                {{ getFormattedTime(segment.arrival.at) }}
                                            </h4>
                                            <span>
                                                {{ getFormattedDate(segment.arrival.at) }}
                                            </span>
                                        </div>
                                        <div>
                                            <div class="ellipsis no-wrap font-sm">
                                                {{ segment.arrival.airportName }}
                                            </div>
                                            <div class="ellipsis no-wrap font-sm">
                                                {{ segment.arrival.iataName }},
                                                {{ segment.arrival.countryName }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="index < itinerary.segments.length - 1" class="col-md-12">
                                    <div class="clearfix layover">
                                        <span>
                                            {{ $t('Stop') }}
                                            {{ getStopDuration(segment.arrival.at,
                                                itinerary.segments[index +
                                                    1].departure.at)
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { formatDate } from '@/utils/dateUtils';
import { convertDuration, formatTime, getStopDuration } from '@/utils/timeUtils';

export default {
    name: 'MultiSelectedFlight',
    props: ['flight', 'searchData', 'getOutboundImg', 'getInboundImg'],
    data: () => ({
        detailedFareRules: null,
    }),
    methods: {
        getFormattedDate(dateString) {
            const { day, month, year } = formatDate(dateString);
            return `${day} ${this.$t(month)} ${year}`;
        },
        getFormattedTime(timeString) {
            return formatTime(timeString);
        },
        convertDuration(duration) {
            return convertDuration(duration, this.$i18n.locale);
        },
        getStopDuration(date, date1) {
            return getStopDuration(this.$i18n.locale, date, date1);
        },
    },
    mounted() {
        this.detailedFareRules = JSON.parse(localStorage.getItem('detailed_fare_rules'));
    }
}
</script>
<style lang="scss" scoped>
.mb0 {
    margin-bottom: 0px;
}
.h4,
h4 {
    font-size: 18px;
}
.mb20 {
    margin-bottom: 20px !important;
}
.no-margin {
    margin: 0;
}
.new-bold-light {
    font-weight: 600;
    font-style: normal;
    color: #0b6938;
}

.itinerary-content {
    background-color: #fff;
    border-radius: 3px;
    padding-bottom: 5px;
}

#outbound-map img {
    width: 100%;
}
.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}
.p10 {
    padding: 10px;
}

.bold {
    font-weight: 500;
    font-style: normal;
}
.ml5 {
    margin-left: 5px !important;
}

.mr5 {
    margin-right: 5px !important;
}

.flight-map {
    width: 100%;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #0b6938;
    min-height: 350px;
}
@media only screen and (max-width: 600px) {
    .flight-map {
        min-height: 100% !important;
    }
}
</style>